<template>
  <v-container>
    <h3 class="mb-4">Anomalie quantita' magazzino</h3>
    <v-row align="center" class="mb-2">
      <v-col cols="12" sm="6" md="4">
        <WarehouseAvailablesSelect
          v-model="filters.warehouse_id"
          :clearable="true"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="filters.search"
          label="Cerca (SKU o prodotto)"
          clearable
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <PropagandistSelect
          v-model="filters.propagandist_id"
          label="Propagandista"
          :clearable="true"
        />
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :options.sync="pagination"
      :loading="loading"
      hide-default-footer
      class="elevation-1"
    >
      <template v-slot:item.eccesso="{ item }">
        <span class="red--text font-weight-bold">
          {{ item.eccesso > 0 ? '+' : '' }}{{ item.eccesso }}
        </span>
      </template>
    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchData"
    />
  </v-container>
</template>
<script>
import { anomalyService } from '../../../utils/services/anomaly.service';
import WarehouseAvailablesSelect from '../../../components/shared/Vselects/WarehouseAvailablesSelect.vue';
import PropagandistSelect from '../../../components/shared/Vselects/PropagandistSelect.vue';
import Paginator from '../../../components/shared/Paginator';

export default {
  name: 'AnomalyVqtyMismatch',
  components: {
    WarehouseAvailablesSelect,
    PropagandistSelect,
    Paginator,
  },
  data() {
    return {
      loading: false,
      items: [],
      totalItems: 0,
      pagination: { page: 1, itemsPerPage: 20 },
      filters: {
        warehouse_id: null,
        search: null,
        propagandist_id: 0,
      },
      headers: [
        { text: 'Magazzino', value: 'magazzino' },
        { text: 'SKU', value: 'sku' },
        { text: 'Prodotto', value: 'prodotto' },
        { text: 'Quantita\'', value: 'qty' },
        { text: 'Disponibilita\'', value: 'vqty' },
        { text: 'Eccesso', value: 'eccesso' },
      ],
    };
  },
  computed: {
    requestFilters() {
      return {
        warehouse_id: this.filters.warehouse_id,
        search: this.filters.search,
        propagandist_id: this.filters.propagandist_id,
      };
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.pagination.page = 1;
        this.fetchData();
      },
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const response = await anomalyService.getVqtyMismatch({
          page: this.pagination.page,
          itemsPerPage: this.pagination.itemsPerPage,
          filters: this.requestFilters,
        });
        this.items = response.data.data;
        this.totalItems = response.data.total;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
